export const tour24PhoneNumber = '8882977411';
export const tour24HelpEmail = 'helpdesk@tour24now.com';



// WEBPACK FOOTER //
// ./src/data/constants.ts